module.exports = __webpack_public_path__ + "img/laterale_dx.e9549996.png";